module.exports = __webpack_public_path__ + "static/media/06.cfd41dbf.png";